import { Button, Divider, Flex, Typography } from "antd"
import { Trans, useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"

import "../styles.less"

const { Text } = Typography

const DaysCounterBanner = ({ days }) => {
  const { t } = useTranslation()
  return (
    <>
      <Flex vertical gap={12} className="additional-message-block">
        <Flex vertical gap={4}>
          <Text style={{ marginBottom: 4 }} type="secondary">
            {t("Days Counter")}
          </Text>
          <Text style={{ fontSize: "14px", lineHeight: "20px" }}>
            {days} {t("days")}
          </Text>
          <Text type="secondary">
            <Trans i18nKey={"You have <1>_days_ days</1> left to move to Balance Billing."} days>
              You have <Text>{{ days }} days</Text> left to move to Balance Billing.
            </Trans>
          </Text>
        </Flex>
        <NavLink to={"/settings/balance?open_add_funds=true"}>
          <Button className="balance-btn" size="small" type="primary">
            {t("Top up balance")}
          </Button>
        </NavLink>
      </Flex>
      <Divider type={"horizontal"} style={{ margin: "16px auto 16px" }} />
    </>
  )
}

export default DaysCounterBanner
